module.exports = __webpack_public_path__ + "img/category-equipment.81003f03.svg";